import { render, staticRenderFns } from "./CreateOrderButton.vue?vue&type=template&id=18d3f86f&scoped=true"
import script from "./CreateOrderButton.vue?vue&type=script&lang=ts"
export * from "./CreateOrderButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3f86f",
  null
  
)

export default component.exports